import { render, staticRenderFns } from "./Preselections.vue?vue&type=template&id=316581ea&scoped=true&"
import script from "./Preselections.vue?vue&type=script&lang=ts&"
export * from "./Preselections.vue?vue&type=script&lang=ts&"
import style0 from "./Preselections.vue?vue&type=style&index=0&id=316581ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316581ea",
  null
  
)

export default component.exports